import { CartEntriesApi } from '@/gen/ecom/apis'
import { ecomConfiguration } from './apiConfigs'

export const cartEntriesClient = new CartEntriesApi(ecomConfiguration)
